module.exports = __webpack_public_path__ + "img/sp02.499601ec.png";